import { render, staticRenderFns } from "./Elevator.vue?vue&type=template&id=4f1f45b3&"
import script from "./Elevator.vue?vue&type=script&lang=js&"
export * from "./Elevator.vue?vue&type=script&lang=js&"
import style0 from "./Elevator.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports